import { makeVar, useReactiveVar } from "@apollo/client"
import type { TermsAndConditions } from "@shared/graphql.types"

const termsAndConditions = makeVar<TermsAndConditions>({
  links: [],
  template: "",
})

export const useTermsAndConditions = (): TermsAndConditions =>
  useReactiveVar(termsAndConditions)

export const setTermsAndConditions = (
  data?: TermsAndConditions | null
): TermsAndConditions => {
  if (!data) return termsAndConditions()

  return termsAndConditions(data)
}
